import React from 'react'

import styles from './index.scss'

export default class LoadingSpinner extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    const {
      isLoading = true
    } = this.props

    return (
      <div className={styles.spinnerWrapper} style={{ opacity: isLoading ? 1 : 0 }}>
        <div className={styles.spinnerContainer}>
          <span className={styles.spinnerA} />
          <span className={styles.spinnerB} />
          <span className={styles.spinnerC} />
          <span className={styles.spinnerD} />
        </div>
      </div>
    )
  }
}
